import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Google 雲端硬碟資料夾")
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "url",
  class: "form-label"
}, "資料夾網址", -1)
const _hoisted_4 = { class: "input-group mb-3" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "* 需將連結分享權限設定為「任何知道這個連結的網際網路使用者都能編輯」", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " 取消 ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "送出", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    confirmHandler: _ctx.confirmHandler,
    onOpen: _ctx.openHandler
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "url",
            class: "form-control",
            "aria-describedby": "button-addon",
            placeholder: _ctx.folderUrl,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.folderUrlValue) = $event)),
            required: ""
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.folderUrlValue]
          ]),
          _createElementVNode("a", {
            class: _normalizeClass(["btn btn-outline-secondary", {
              disabled: !_ctx.folderId,
            }]),
            id: "button-addon",
            href: _ctx.folderUrl,
            target: "_blank"
          }, " 開啟資料夾 ", 10, _hoisted_6)
        ]),
        _hoisted_7
      ])
    ]),
    footer: _withCtx(() => [
      _hoisted_8,
      _hoisted_9
    ]),
    _: 1
  }, 8, ["confirmHandler", "onOpen"]))
}